import { render, staticRenderFns } from "./BusinessDepartment.vue?vue&type=template&id=5ec1d6ce&scoped=true&"
import script from "./BusinessDepartment.vue?vue&type=script&lang=js&"
export * from "./BusinessDepartment.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDepartment.vue?vue&type=style&index=0&id=5ec1d6ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1d6ce",
  null
  
)

export default component.exports